import { styled } from '@linaria/react';
import { colors, fonts } from '../../theme/tokens';

export const Heading = styled.h2`
  font-family: ${fonts.body};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontPrimary};
  margin: 0;
`;

export const Accent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontSecondary};
`;
